var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgSklad = function SvgSklad(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.797 1.21a.5.5 0 0 1 .406 0l8.334 3.703a.5.5 0 0 1 .297.457v9.26a.5.5 0 0 1-.297.457l-8.334 3.703a.5.5 0 0 1-.406 0l-8.333-3.703a.5.5 0 0 1-.297-.457V5.37a.5.5 0 0 1 .297-.457L9.797 1.21Zm-7.63 4.93 3.167 1.407v4.305a.5.5 0 0 0 1 0v-3.86L9.5 9.399v8.165l-7.333-3.26V6.14ZM10.5 17.564l7.334-3.26V6.14L10.5 9.399v8.165ZM10 8.527l7.103-3.157-2.936-1.304-7.102 3.156L10 8.527ZM5.834 6.675l7.102-3.156L10 2.214 2.898 5.37l2.936 1.305Z",
    fill: "#818C96"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.797 1.21a.5.5 0 0 1 .406 0l8.334 3.703a.5.5 0 0 1 .297.457v9.26a.5.5 0 0 1-.297.457l-8.334 3.703a.5.5 0 0 1-.406 0l-8.333-3.703a.5.5 0 0 1-.297-.457V5.37a.5.5 0 0 1 .297-.457L9.797 1.21Zm-7.63 4.93 3.167 1.407v4.305a.5.5 0 0 0 1 0v-3.86L9.5 9.399v8.165l-7.333-3.26V6.14ZM10.5 17.564l7.334-3.26V6.14L10.5 9.399v8.165ZM10 8.527l7.103-3.157-2.936-1.304-7.102 3.156L10 8.527ZM5.834 6.675l7.102-3.156L10 2.214 2.898 5.37l2.936 1.305Z",
    fill: "#747F88"
  })));
};

export default SvgSklad;